module.exports = __webpack_public_path__ + "img/2020_11_24_gator.d8a520bc.jpg";